import { Box, Typography, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import GridViewIcon from "@mui/icons-material/GridView";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";


import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { useDispatch } from "react-redux";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

type Props = {
    fileUrl: string;
};

const PdfViewer: React.FC<Props> = ({ fileUrl }) => {
    const [numPages, setNumPages] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [scale, setScale] = useState<number>(1.2);



    return (
        <div className="flex flex-col items-center">
            <div className="bg-gray-100 p-4 rounded-md shadow">
                <Document file={fileUrl} onLoadSuccess={({ numPages }) => setNumPages(numPages)}>
                    <Page pageNumber={pageNumber} scale={scale} />
                </Document>
            </div>
            <Box
                sx={{
                    px: 2,
                    py: 1,
                    bgcolor: "grey.100",
                    borderRadius: 2,
                    minWidth: 70,
                    textAlign: "center",
                }}
            >
                <Typography fontWeight={500}>
                    {String(pageNumber).padStart(2, "0")}/{String(numPages).padStart(2, "0")}
                </Typography>
            </Box>

            <Box className="flex gap-4 justify-center items-center">
                <IconButton onClick={() => setPageNumber(1)} disabled={pageNumber <= 1}>
                    <FirstPageIcon />
                </IconButton>
                <IconButton
                    disabled={pageNumber <= 1}
                    onClick={() => setPageNumber(pageNumber - 1)}
                >
                    <ChevronLeftIcon />
                </IconButton>


                {/* <IconButton>
                    <GridViewIcon />
                </IconButton> */}

                <IconButton onClick={() => setScale(scale + 0.2)}>
                    <AddIcon />
                </IconButton>

                <IconButton onClick={() => setScale(scale - 0.2)} disabled={scale <= 0.5}>
                    <RemoveIcon />
                </IconButton>

                <IconButton
                    disabled={pageNumber >= numPages}
                    onClick={() => setPageNumber(pageNumber + 1)}
                >
                    <ChevronRightIcon />
                </IconButton>

                <IconButton
                    onClick={() => setPageNumber(numPages)}
                    disabled={pageNumber >= numPages}
                >
                    <LastPageIcon />
                </IconButton>
            </Box>
        </div>
    );
};

export default PdfViewer;
